<template>
<span v-if="currentSortKey === sortKey" class="ml-1 text-[15px] align-middle">
                    <span v-if="sortOrder === 1">▼</span>
                    <span v-else>▲</span>
                </span>
    <span v-else class="ml-1 text-[15px] align-middle opacity-[0.5]">▼</span>
</template>
<script>
export default {
    name: 'SortChevron',
    props: {
        currentSortKey: {},
        sortKey: {},
        sortOrder: {},
    }
}
</script>
